import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones de forma estática para mejor performance
// Esto permite que webpack las incluya en el bundle de forma optimizada
import esTranslation from './locales/es/translation.json';
import enTranslation from './locales/en/translation.json';

// Función para obtener el idioma guardado en localStorage
// Optimizada para evitar lecturas innecesarias
const getStoredLanguage = (): string => {
  try {
    const stored = localStorage.getItem('i18nextLng');
    if (stored === 'es' || stored === 'en') {
      return stored;
    }
  } catch (e) {
    // Si hay error accediendo a localStorage, usar español por defecto
  }
  return 'es'; // Español por defecto
};

// Inicializar i18next con optimizaciones de performance
i18n
  // Detectar idioma del navegador o usar el guardado
  .use(LanguageDetector)
  // Pasar la instancia de i18n a react-i18next
  .use(initReactI18next)
  // Inicializar i18next
  .init({
    // Idioma por defecto (obtenido de localStorage o español)
    lng: getStoredLanguage(),
    
    // Fallback al español si falta una traducción
    fallbackLng: 'es',
    
    // Namespace por defecto
    defaultNS: 'translation',
    
    // Debug solo en desarrollo (desactivado para mejor performance)
    debug: false,
    
    // Recursos de traducción cargados de forma estática
    // Esto permite que webpack los optimice y los incluya en el bundle
    resources: {
      es: {
        translation: esTranslation
      },
      en: {
        translation: enTranslation
      }
    },
    
    // Opciones de interpolación
    interpolation: {
      escapeValue: false // React ya escapa los valores, no necesitamos escapar de nuevo
    },
    
    // Opciones de detección de idioma
    detection: {
      // Orden de detección: primero localStorage (más rápido), luego navigator
      order: ['localStorage', 'navigator'],
      // Clave en localStorage donde se guarda el idioma
      lookupLocalStorage: 'i18nextLng',
      // Cache del idioma detectado en localStorage
      caches: ['localStorage']
    },
    
    // React i18next options
    react: {
      // No usar Suspense para evitar delays en la carga inicial
      // Esto mejora el tiempo de primera renderización
      useSuspense: false
    }
  });

export default i18n;









